export const internalErrorPageHeading = 'We got a little zapped.'
export const internalErrorPageCopy =
	'Something went wrong on our end. Try again in a moment, or go home and pick up from there.'
export const internalErrorPageImageSrc = '/images/kody-500-zapped.png'
export const internalErrorPageImageAlt =
	'Kody with sparking fur holding two cables that just shorted'
